import Vue from "vue";
import Vuex from "vuex";
import { userLogin, userLogOut } from "../../utils/apiFunctions.js";
import {
  setToken,
  getRefreshToken,
  getToken,
  clearCookies,
} from "../../utils/tokenCheck";
import store from "../index.js";

const qs = require("qs");

Vue.use(Vuex);

const state = () => ({
  userData: {
    firstName: "",
    lastName: "",
    email: "",
    image: "",
  },
  token: "",
  refreshToken: "",
  errorMessage: "",
  userDetails: {
    firstName: "",
    lastName: "",
    email: "",
    image: "",
  },
});

const getters = {
  checkLoginStatus: (state) => state.loggedin,
  getErrorMessage: (state) => state.errorMessage,
  getLoginHeaderFromHeaderVuex: () => store.state.headerVuex.loginHeader,
  getUserDetails: (state) => state.userDetails,
  getUserData: (state) => state.userData,
};
// actions
const actions = {
  Login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      userLogin(userInfo.keycloak)
        .then((response) => {
          const data = response.data;
          if (data.access_token) {
            setToken(data.access_token);
            commit("SET_TOKEN", data.access_token);
            commit("SET_REFRESH_TOKEN", data.refresh_token);
            resolve(response);
          } else {
            reject(data);
          }
        })
        .catch((error) => {
          commit("SET_ERROR_MESSAGE", error.response.data.error_description);
          reject(error);
        });
    });
  },
  LogOut({ commit }) {
    userLogOut(
      qs.stringify({
        client_id: "vue-test-app",
        refresh_token: getRefreshToken(),
      }),
      {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        Authorization: `Bearer ${getToken()}`,
      }
    )
      .then((response) => {
        commit("SET_TOKEN", "");
        commit("SET_REFRESH_TOKEN", "");
        localStorage.clear();
        clearCookies();
        // location.replace("http://localhost:8080/login");
        location.replace("https://app.hire3x.com/login");
        return response;
        // alert("User Logged Out");
      })
      .catch((error) => {
        commit("SET_TOKEN", "");
        commit("SET_REFRESH_TOKEN", "");
        localStorage.clear();
        clearCookies();
        // location.replace("http://localhost:8080/login");
        location.replace("https://app.hire3x.com/login");
        console.log(error);
      });
  },
};
// mutations
const mutations = {
  setUserData(state, payload) {
    console.log(payload);
    state.userData = payload;
    console.log("user", state.userData);
  },
  checkLoginStatus(state, payload) {
    state.loggedin = payload;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_REFRESH_TOKEN(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  SET_ERROR_MESSAGE(state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  SET_USER_DETAILS(state, userDetails) {
    state.userDetails = userDetails;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
